// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DBBaseElement } from './DBBaseElement';
import { BEAttribute } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { DBTable } from './DBTable';
import { ForeignKey } from './ForeignKey';
import { PrimaryKey } from './PrimaryKey';
import { DefaultConstaint } from './DefaultConstaint';
import { IndexColumn } from './IndexColumn';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 数据库列 实体类
 * 数据库列
 */
export class DBColumn extends DBBaseElement {
  /** 数据类型 : 数据库数据类型 */
  private _dataType: EnumDataType;

  /** 设置：数据类型 */
  public get dataType() {
    return this._dataType;
  }

  /** 获取：数据类型 */
  public set dataType(value: EnumDataType) {
    this._dataType = value;
  }

  /** 是否可空 : 是否可空 */
  private _isNullable: boolean;

  /** 设置：是否可空 */
  public get isNullable() {
    return this._isNullable;
  }

  /** 获取：是否可空 */
  public set isNullable(value: boolean) {
    this._isNullable = value;
  }

  /** 长度 : 字段长度 */
  private _length: number;

  /** 设置：长度 */
  public get length() {
    return this._length;
  }

  /** 获取：长度 */
  public set length(value: number) {
    this._length = value;
  }

  /** 精度 : 数字型属性的精度，-1为不限制 */
  private _precision: number;

  /** 设置：精度 */
  public get precision() {
    return this._precision;
  }

  /** 获取：精度 */
  public set precision(value: number) {
    this._precision = value;
  }

  /** 小数位数 : 数字型属性的小数位数，针对浮点数值 */
  private _scale: number;

  /** 设置：小数位数 */
  public get scale() {
    return this._scale;
  }

  /** 获取：小数位数 */
  public set scale(value: number) {
    this._scale = value;
  }

  /** 是否固定长度 : 是否固定长度 */
  private _isFixLength: boolean;

  /** 设置：是否固定长度 */
  public get isFixLength() {
    return this._isFixLength;
  }

  /** 获取：是否固定长度 */
  public set isFixLength(value: boolean) {
    this._isFixLength = value;
  }

  /** 是否包含Unicode字符 : 是否包含Unicode字符。 */
  private _isUnicode: boolean;

  /** 设置：是否包含Unicode字符 */
  public get isUnicode() {
    return this._isUnicode;
  }

  /** 获取：是否包含Unicode字符 */
  public set isUnicode(value: boolean) {
    this._isUnicode = value;
  }

  /** 是否无符号 : 是否无符号，对整型有效，默认false */
  private _isUnsigned: boolean;

  /** 设置：是否无符号 */
  public get isUnsigned() {
    return this._isUnsigned;
  }

  /** 获取：是否无符号 */
  public set isUnsigned(value: boolean) {
    this._isUnsigned = value;
  }

  /** 绑定属性 的ID */
  private _bindingBEAttribute_ID: string;

  /** 获取：绑定属性 的ID */
  public get bindingBEAttribute_ID() {
    return this._bindingBEAttribute_ID;
  }

  /** 设置：绑定属性 的ID */
  public set bindingBEAttribute_ID(value: string) {
    this._bindingBEAttribute_ID = value;
  }

  /** 绑定属性  */
  private _bindingBEAttribute: BEAttribute;

  /** 获取：绑定属性  */
  public get bindingBEAttribute() {
    return this._bindingBEAttribute;
  }

  /** 设置：绑定属性  */
  public set bindingBEAttribute(value: BEAttribute) {
    this._bindingBEAttribute = value;
    if (value !== null) {
      this.bindingBEAttribute_ID = value.id;
    } else {
      this.bindingBEAttribute_ID = '';
    }
  }

  /** 数据库表 的ID */
  private _table_ID: string;

  /** 获取：数据库表 的ID */
  public get table_ID() {
    return this._table_ID;
  }

  /** 设置：数据库表 的ID */
  public set table_ID(value: string) {
    this._table_ID = value;
  }

  /** 数据库表  */
  private _table: DBTable;

  /** 获取：数据库表  */
  public get table() {
    return this._table;
  }

  /** 设置：数据库表  */
  public set table(value: DBTable) {
    this._table = value;
    if (value !== null) {
      this.table_ID = value.id;
    } else {
      this.table_ID = '';
    }
  }

  /** 外键约束 */
  private _foreignKeys: Array<ForeignKey>;

  /** 获取：外键约束 */
  public get foreignKeys() {
    return this._foreignKeys;
  }

  /** 设置：外键约束 */
  public set foreignKeys(value: Array<ForeignKey>) {
    this._foreignKeys = value;
  }

  /** 作为引用的外键约束 */
  private _referenceForeignKeys: Array<ForeignKey>;

  /** 获取：作为引用的外键约束 */
  public get referenceForeignKeys() {
    return this._referenceForeignKeys;
  }

  /** 设置：作为引用的外键约束 */
  public set referenceForeignKeys(value: Array<ForeignKey>) {
    this._referenceForeignKeys = value;
  }

  /** 主键 的ID */
  private _primaryKey_ID: string;

  /** 获取：主键 的ID */
  public get primaryKey_ID() {
    return this._primaryKey_ID;
  }

  /** 设置：主键 的ID */
  public set primaryKey_ID(value: string) {
    this._primaryKey_ID = value;
  }

  /** 主键  */
  private _primaryKey: PrimaryKey;

  /** 获取：主键  */
  public get primaryKey() {
    return this._primaryKey;
  }

  /** 设置：主键  */
  public set primaryKey(value: PrimaryKey) {
    this._primaryKey = value;
    if (value !== null) {
      this.primaryKey_ID = value.id;
    } else {
      this.primaryKey_ID = '';
    }
  }

  /** 缺省约束 的ID */
  private _defaultConstaint_ID: string;

  /** 获取：缺省约束 的ID */
  public get defaultConstaint_ID() {
    return this._defaultConstaint_ID;
  }

  /** 设置：缺省约束 的ID */
  public set defaultConstaint_ID(value: string) {
    this._defaultConstaint_ID = value;
  }

  /** 缺省约束  */
  private _defaultConstaint: DefaultConstaint;

  /** 获取：缺省约束  */
  public get defaultConstaint() {
    return this._defaultConstaint;
  }

  /** 设置：缺省约束  */
  public set defaultConstaint(value: DefaultConstaint) {
    this._defaultConstaint = value;
    if (value !== null) {
      this.defaultConstaint_ID = value.id;
    } else {
      this.defaultConstaint_ID = '';
    }
  }

  /** 索引列 */
  private _indexColumns: Array<IndexColumn>;

  /** 获取：索引列 */
  public get indexColumns() {
    return this._indexColumns;
  }

  /** 设置：索引列 */
  public set indexColumns(value: Array<IndexColumn>) {
    this._indexColumns = value;
  }

  constructor() {
    super();
    this._dataType = EnumDataType.String;
    this._isNullable = true;
    this._length = 50;
    this._precision = 0;
    this._scale = 0;
    this._isFixLength = false;
    this._isUnicode = false;
    this._isUnsigned = false;
    this._bindingBEAttribute_ID = '';
    this._bindingBEAttribute = null;
    this._table_ID = '';
    this._table = null;
    this._foreignKeys = new Array<ForeignKey>();
    this._referenceForeignKeys = new Array<ForeignKey>();
    this._primaryKey_ID = '';
    this._primaryKey = null;
    this._defaultConstaint_ID = '';
    this._defaultConstaint = null;
    this._indexColumns = new Array<IndexColumn>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DBColumn, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.dataType = element.dataType;
      this.isNullable = element.isNullable;
      this.length = element.length;
      this.precision = element.precision;
      this.scale = element.scale;
      this.isFixLength = element.isFixLength;
      this.isUnicode = element.isUnicode;
      this.isUnsigned = element.isUnsigned;
      this.bindingBEAttribute_ID = element.bindingBEAttribute_ID;
      if (hasReference && element.bindingBEAttribute !== null) {
        this.bindingBEAttribute = element.bindingBEAttribute;
      }
      this.table_ID = element.table_ID;
      if (hasReference && element.table !== null) {
        this.table = element.table;
      }
      this.primaryKey_ID = element.primaryKey_ID;
      if (hasReference && element.primaryKey !== null) {
        this.primaryKey = element.primaryKey;
      }
      this.defaultConstaint_ID = element.defaultConstaint_ID;
      if (hasReference && element.defaultConstaint !== null) {
        this.defaultConstaint = element.defaultConstaint;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.dataType = json.DataType as EnumDataType;
    this.isNullable = json.IsNullable;
    this.length = json.Length;
    this.precision = json.Precision;
    this.scale = json.Scale;
    this.isFixLength = json.IsFixLength;
    this.isUnicode = json.IsUnicode;
    this.isUnsigned = json.IsUnsigned;
    this.bindingBEAttribute_ID = json.BindingBEAttribute_ID;
    // if (json.BindingBEAttribute !== null) {
    //   this.bindingBEAttribute = BEAttribute.Create(json.BindingBEAttribute);
    // }
    this.table_ID = json.Table_ID;
    // if (json.Table !== null) {
    //   this.table = DBTable.Create(json.Table);
    // }
    if (json.ForeignKeys && json.ForeignKeys.length > 0) {
      json.ForeignKeys.forEach((element: any) => {
        const foreignKey = ForeignKey.Create(element);
        // foreignKey.column = this;
        this.foreignKeys.push(foreignKey);
      });
    }
    if (json.ReferenceForeignKeys && json.ReferenceForeignKeys.length > 0) {
      json.ReferenceForeignKeys.forEach((element: any) => {
        const foreignKey = ForeignKey.Create(element);
        // foreignKey.referenceColumn = this;
        this.referenceForeignKeys.push(foreignKey);
      });
    }
    this.primaryKey_ID = json.PrimaryKey_ID;
    // if (json.PrimaryKey !== null) {
    //   this.primaryKey = PrimaryKey.Create(json.PrimaryKey);
    // }
    this.defaultConstaint_ID = json.DefaultConstaint_ID;
    // if (json.DefaultConstaint !== null) {
    //   this.defaultConstaint = DefaultConstaint.Create(json.DefaultConstaint);
    // }
    if (json.IndexColumns && json.IndexColumns.length > 0) {
      json.IndexColumns.forEach((element: any) => {
        const indexColumn = IndexColumn.Create(element);
        // indexColumn.column = this;
        this.indexColumns.push(indexColumn);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DataType = this.dataType;
    json.IsNullable = this.isNullable;
    json.Length = this.length;
    json.Precision = this.precision;
    json.Scale = this.scale;
    json.IsFixLength = this.isFixLength;
    json.IsUnicode = this.isUnicode;
    json.IsUnsigned = this.isUnsigned;
    json.BindingBEAttribute_ID = this.bindingBEAttribute_ID;
    json.Table_ID = this.table_ID;
    if (this.foreignKeys && this.foreignKeys.length > 0) {
      json.ForeignKeys = [];
      this.foreignKeys.forEach((element) => {
        json.ForeignKeys.push(element.toJson());
      });
    }
    if (this.referenceForeignKeys && this.referenceForeignKeys.length > 0) {
      json.ReferenceForeignKeys = [];
      this.referenceForeignKeys.forEach((element) => {
        json.ReferenceForeignKeys.push(element.toJson());
      });
    }
    json.PrimaryKey_ID = this.primaryKey_ID;
    json.DefaultConstaint_ID = this.defaultConstaint_ID;
    if (this.indexColumns && this.indexColumns.length > 0) {
      json.IndexColumns = [];
      this.indexColumns.forEach((element) => {
        json.IndexColumns.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'dataType', '数据类型', EnumDataType.Reference, this.dataType, true, '数据库数据类型', 'EnumDataType', '');
    context.addRow('基本属性', 'isNullable', '是否可空', EnumDataType.Bool, this.isNullable, true, '是否可空', '', '');
    context.addRow('基本属性', 'length', '长度', EnumDataType.Int, this.length, true, '字段长度', '', '');
    context.addRow('基本属性', 'precision', '精度', EnumDataType.Int, this.precision, true, '数字型属性的精度，-1为不限制', '', '');
    context.addRow('基本属性', 'scale', '小数位数', EnumDataType.Int, this.scale, true, '数字型属性的小数位数，针对浮点数值', '', '');
    context.addRow('基本属性', 'isFixLength', '是否固定长度', EnumDataType.Bool, this.isFixLength, true, '是否固定长度', '', '');
    context.addRow('基本属性', 'isUnicode', '是否包含Unicode字符', EnumDataType.Bool, this.isUnicode, true, '是否包含Unicode字符。', '', '');
    context.addRow('基本属性', 'isUnsigned', '是否无符号', EnumDataType.Bool, this.isUnsigned, true, '是否无符号，对整型有效，默认false', '', '');
    context.addRow('基本属性', 'bindingBEAttribute', '绑定属性', EnumDataType.Reference, this.bindingBEAttribute, true, '绑定属性', 'BEAttribute', '');
    return context;
  }

  static Create(json: any): DBColumn {
    const dBColumn = new DBColumn();
    dBColumn.Deserialize(json);
    dBColumn.json = json;
    return dBColumn;
  }
}
